import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

interface IProps {
  headerImageElement: React.ReactNode;
  icon: React.ReactNode;
  title: string;
  description: React.ReactNode | string;
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    border: '1px solid #E0E0E0',
    borderRadius: 8
  },
  header: {
    background: '#F5F5F5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 100,
    '@media screen and (min-width: 1600px)': {
      justifyContent: 'initial',
      gap: 32
    },
    '& img': {
      height: '100%'
    }
  },
  title: {
    padding: '0 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    fontSize: '1rem',
    color: theme.variables.colors['cardPrimaryColor'],
    fontWeight: 700,
    '@media screen and (min-width: 1600px)': {
      minWidth: '30%'
    },
    '& svg': {
      fill: theme.variables.colors['cardPrimaryColor'],
      width: 32
    }
  },
  description: {
    fontSize: '0.875rem',
    padding: '8px 16px',
    color: '#666666'
  }
}));

const Card: React.FC<IProps> = ({ icon, title, description, headerImageElement }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div className={classes.title}>
          {icon}
          {title}
        </div>
        {headerImageElement}
      </div>
      <div className={classes.description}>{description}</div>
    </div>
  );
};

export default React.memo(Card);
